import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { Badge, Button, Col, Row, Table } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Success from '../../assets/images/check.svg';
import Fail from '../../assets/images/fail.svg';
import Warn from '../../assets/images/warn.svg';
import './style.scss';

const HollandResult = ({ score }) => {
  const endPageRef = useRef(null);
  const history = useHistory();
  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    endPageRef?.current?.scrollIntoView({ behavior: 'smooth', duration: 2500 });
  }, []);

  const handleBack = () => {
    history.replace('/');
  };

  const renderStatus = (value) => {
    if (value === 0) {
      return <img src={Fail} alt="Trung Tâm Phát Triển Năng Lực - Đại Học Văn Lang" width="48" />;
    } if (value < 0.6) {
      return <img src={Warn} alt="Trung Tâm Phát Triển Năng Lực - Đại Học Văn Lang" width="48" />;
    }
    return <img src={Success} alt="Trung Tâm Phát Triển Năng Lực - Đại Học Văn Lang" width="48" />;
  };

  const renderResult = () => (
    <>
      <Row className="text-center">
        <Col md={4}>
          <p>
            <img src={Success} alt="Trung Tâm Phát Triển Năng Lực - Đại Học Văn Lang" width="48" />
          </p>
          <h6><Badge variant="success">Bạn hoàn toàn có khả năng</Badge></h6>
        </Col>
        <Col md={4}>
          <p>
            <img src={Warn} alt="Trung Tâm Phát Triển Năng Lực - Đại Học Văn Lang" width="48" />
          </p>
          <h6><Badge variant="warning">Bạn cần cải thiện thêm khả năng</Badge></h6>
        </Col>
        <Col md={4}>
          <p>
            <img src={Fail} alt="Trung Tâm Phát Triển Năng Lực - Đại Học Văn Lang" width="48" />
          </p>
          <h6><Badge variant="danger">Bạn không có hoặc không hứng thú</Badge></h6>
        </Col>
      </Row>
      <Table responsive striped bordered hover>
        <tbody>
          {Object.keys(score).map(item => (
            <tr key={item}>
              <td>
                <h4><Badge variant="info">{score[item].group}</Badge></h4>
              </td>
              <td><p className="text-center">{score[item].text}</p></td>
              <td>{renderStatus(score[item].value)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );

  return (
    <div className="skills-result">
      {renderResult()}
      <div className="text-center">
        <Button onClick={handleBack} variant="success">Quay về trang chủ</Button>
      </div>
    </div>
  );
};

HollandResult.propTypes = {
  score: PropTypes.shape({}).isRequired
};

export default HollandResult;
